import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.inverse};
  height: 100%;
`;

export const Message = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.inverse};
  margin-top: 15px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  text-align: center;
  white-space: pre-wrap;
`;
